// extracted by mini-css-extract-plugin
export default {"p":"P_p__qMuDQ"};